module.exports = __webpack_public_path__ + "img/user.5da1538d.svg";